import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.outcome.fields.id'),
  },
  {
    name: 'description',
    label: i18n('entities.outcome.fields.description'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.outcome.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.outcome.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
